import React, { forwardRef, memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Checkbox as EvergreenCheckbox } from 'evergreen-ui';
import cn from 'classnames';

import styles from './styles.module.scss';

const Checkbox = forwardRef(({
  checked, onChange, name, label, disabled, className, ...props
}, ref) => {
  const onValueChange = useCallback((e) => {
    onChange(e.target.checked);
  }, [onChange]);

  return (
    <EvergreenCheckbox
      ref={ref}
      name={name}
      label={label}
      checked={checked}
      disabled={disabled}
      className={cn(styles.checkbox, className)}
      onChange={onValueChange}
      {...props}
    />
  );
});

Checkbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

Checkbox.defaultProps = {
  checked: null,
  onChange: null,
  name: null,
  label: '',
  disabled: false,
  className: null,
};

export default memo(Checkbox);
